import type { JSX } from "react";

import {
  // Austrian banks (SmallLogo used as large logo fallback)
  IconAddikoSmallLogo,
  IconAerzteApothekerbankSmallLogo,
  IconAirbankLogo,
  IconAliorBankLogo,
  IconAnadiSmallLogo,
  IconArgentexSmallLogo,
  IconBank365Logo,
  IconBankPekaoLogo,
  IconBank99SmallLogo,
  IconBankAustriaSmallLogo,
  IconBankAustriaUnicreditSmallLogo,
  IconBankBurgenlandSmallLogo,
  IconBankWinterSmallLogo,
  IconBankhausSchelhammerSmallLogo,
  IconBankhausSpanglerSmallLogo,
  IconBawagLogo,
  IconBcLogo,
  IconBksSmallLogo,
  IconBtvSmallLogo,
  IconCommerzbankLogo,
  IconConsorsFinanzSmallLogo,
  IconCreditasLogo,
  IconCsasLogo,
  IconCsobLogo,
  IconDeutscheBankLogo,
  IconDolomitenSmallLogo,
  IconEasybankSmallLogo,
  IconEdbSmallLogo,
  IconErsteSmallLogo,
  IconFioLogo,
  IconFrankfurterVolksbankLogo,
  IconGeneraliSmallLogo,
  IconHypoNoeSmallLogo,
  IconHypoTirolSmallLogo,
  IconHypovereinsbankLogo,
  IconHypoVorarlbergSmallLogo,
  IconIngLogo,
  IconJTBankLogo,
  IconJuniSmallLogo,
  IconKbLogo,
  IconMarchfelderSmallLogo,
  IconMbankLogo,
  IconMillenniumLogo,
  IconMonetaLogo,
  IconN26SmallLogo,
  IconOberbankSmallLogo,
  IconPaypalSmallLogo,
  IconPkoBpLogo,
  IconPostbankLogo,
  IconQontoLogo,
  IconRbLogo,
  IconRevolutSmallLogo,
  IconSchoellerbankSmallLogo,
  IconSlovenskaSporitelnaLogo,
  IconSpardaSmallLogo,
  IconSwanSmallLogo,
  IconTatraBankaLogo,
  IconUnicreditLogo,
  IconVolksbankKaerntenSmallLogo,
  IconVolksbankNoeSmallLogo,
  IconVolksbankOoeSmallLogo,
  IconVolksbankSalzburgSmallLogo,
  IconVolksbankSteiermarkSmallLogo,
  IconVolksbankTirolSmallLogo,
  IconVolksbankVorarlbergSmallLogo,
  IconVolksbankWienSmallLogo,
  IconVrBankSmallLogo,
  IconVubLogo,
  IconWamoSmallLogo,
  IconWiseSmallLogo,
  IconBnpParibasLogo,
  IconCitiHandlowyLogo,
  IconHsbcLogo,
  IconLbbwLogo,
  IconSparkasseLogo,
} from "@dfp/react-bank-logos";

import { BankKeys } from "../BankAvatar/index.ts";

export const bankLogoMap: Record<BankKeys, JSX.ElementType> = {
  "Fio banka, a.s.": IconFioLogo,
  Fio: IconFioLogo,
  FIO: IconFioLogo,
  FIOBCZPP: IconFioLogo,
  FIOBCZPPXXX: IconFioLogo,
  "Komerční banka, a.s.": IconKbLogo,
  KB: IconKbLogo,
  KOMBCZPPXXX: IconKbLogo,
  KOMBCZPP: IconKbLogo,
  "Air Bank a.s.": IconAirbankLogo,
  AIRBANK: IconAirbankLogo,
  AIRACZPP: IconAirbankLogo,
  AIRACZPPXXX: IconAirbankLogo,
  "Banka CREDITAS a.s.": IconCreditasLogo,
  CREDITAS: IconCreditasLogo,
  CTASCZ22: IconCreditasLogo,
  CTASCZ22XXX: IconCreditasLogo,
  "Česká spořitelna, a.s.": IconCsasLogo,
  CSAS: IconCsasLogo,
  GIBACZPX: IconCsasLogo,
  GIBACZPXXXX: IconCsasLogo,
  "ČSOB, a.s.": IconCsobLogo,
  CSOB: IconCsobLogo,
  CEKOCZPP: IconCsobLogo,
  CEKOCZPPXXX: IconCsobLogo,
  "J&T BANKA, a.s.": IconJTBankLogo,
  JTB: IconJTBankLogo,
  JTBPCZPP: IconJTBankLogo,
  JTBPCZPPXXX: IconJTBankLogo,
  "mBank S.A., organizační složka": IconMbankLogo,
  MBANK: IconMbankLogo,
  BREXCZPP: IconMbankLogo,
  BREXCZPPXXX: IconMbankLogo,
  "MONETA Money Bank, a.s.": IconMonetaLogo,
  MONETA: IconMonetaLogo,
  AGBACZPP: IconMonetaLogo,
  AGBACZPPXXX: IconMonetaLogo,
  "Raiffeisenbank, a.s.": IconRbLogo,
  RAIFFEISEN: IconRbLogo,
  RZBCCZPP: IconRbLogo,
  RZBCCZPPXXX: IconRbLogo,
  "UniCredit Bank Czech Republic and Slovakia, a.s.": IconUnicreditLogo,
  UNICREDIT: IconUnicreditLogo,
  BACXCZPP: IconUnicreditLogo,
  BACXCZPPXXX: IconUnicreditLogo,
  // Mockup
  "Banking Circle SA": IconBcLogo,
  BC: IconBcLogo,
  // Slovak banks
  BREXSKBX: IconMbankLogo,
  GIBASKBX: IconSlovenskaSporitelnaLogo,
  CEKOSKBX: IconCsobLogo,
  TATRSKBX: IconTatraBankaLogo,
  SUBASKBX: IconVubLogo,
  POBNSKBA: IconBank365Logo,
  // Polish banks
  BREXPLPW: IconMbankLogo,
  ALBPPLPW: IconAliorBankLogo,
  PKOPPLPW: IconBankPekaoLogo,
  BPKOPLPW: IconPkoBpLogo,
  BIGBPLPW: IconMillenniumLogo,
  INGBPLPW: IconIngLogo,
  // German banks
  DEUTDEFF: IconDeutscheBankLogo,
  COBADEFF: IconCommerzbankLogo,
  FFVBDEFF: IconFrankfurterVolksbankLogo,
  HYVEDEMM: IconHypovereinsbankLogo,
  PBNKDEFF: IconPostbankLogo,
  QNTODEB2: IconQontoLogo,
  // Austrian banks — provider values
  argentex_oauth_client_at: IconArgentexSmallLogo,
  btv_client_at: IconBtvSmallLogo,
  oberbank_client_at: IconOberbankSmallLogo,
  bks_client_at: IconBksSmallLogo,
  consors_finanz_client_at: IconConsorsFinanzSmallLogo,
  addiko_bank_oauth_client_at: IconAddikoSmallLogo,
  anadi_bank_oauth_client_at: IconAnadiSmallLogo,
  bawag_psk_oauth_client_at: IconBawagLogo,
  easybank_oauth_client_at: IconEasybankSmallLogo,
  sparda_oauth_client_at: IconSpardaSmallLogo,
  bank_99_oauth_client_at: IconBank99SmallLogo,
  bank_burgenland_oauth_client_at: IconBankBurgenlandSmallLogo,
  bank_winter_oauth_client_at: IconBankWinterSmallLogo,
  bankhaus_spangler_oauth_client_at: IconBankhausSpanglerSmallLogo,
  erste_bank_sparkassen_oauth_client_at: IconErsteSmallLogo,
  edb_oauth_client_at: IconEdbSmallLogo,
  generali_bank_oauth_client_at: IconGeneraliSmallLogo,
  hypo_noe_oauth_client_at: IconHypoNoeSmallLogo,
  hypo_tirol_oauth_client_at: IconHypoTirolSmallLogo,
  hypo_vorarlberg_oauth_client_at: IconHypoVorarlbergSmallLogo,
  juni_oauth_client_at: IconJuniSmallLogo,
  n26_xs2a_oauth_client_at: IconN26SmallLogo,
  paypal_oauth_client_at: IconPaypalSmallLogo,
  raiffeisen_client_at: IconRbLogo,
  revolut_oauth_client_at: IconRevolutSmallLogo,
  swan_oauth_client_at: IconSwanSmallLogo,
  schoellerbank_oauth_client_at: IconSchoellerbankSmallLogo,
  unicredit_business_oauth_client_at: IconBankAustriaUnicreditSmallLogo,
  unicredit_oauth_client_at: IconBankAustriaUnicreditSmallLogo,
  vr_bank_rottal_inn_eg_oauth_client_at: IconVrBankSmallLogo,
  volksbank_niederosterreich_oauth_client_at: IconVolksbankNoeSmallLogo,
  volksbank_oberosterreich_oauth_client_at: IconVolksbankOoeSmallLogo,
  volksbank_salzburg_oauth_client_at: IconVolksbankSalzburgSmallLogo,
  volksbank_steiermark_oauth_client_at: IconVolksbankSteiermarkSmallLogo,
  volksbank_tirol_oauth_client_at: IconVolksbankTirolSmallLogo,
  volksbank_vorarlberg_oauth_client_at: IconVolksbankVorarlbergSmallLogo,
  volksbank_kaernten_oauth_client_at: IconVolksbankKaerntenSmallLogo,
  dolomiten_bank_oauth_client_at: IconDolomitenSmallLogo,
  marchfelder_bank_oauth_client_at: IconMarchfelderSmallLogo,
  osterreichische_arzte_und_apothekerbank_oauth_client_at:
    IconAerzteApothekerbankSmallLogo,
  wamo_oauth_client_at: IconWamoSmallLogo,
  transferwise_oauth_client_at: IconWiseSmallLogo,
  // Austrian banks — BIC codes
  Argentex: IconArgentexSmallLogo,
  ARTXGB2L: IconArgentexSmallLogo,
  ARTXGB2LXXX: IconArgentexSmallLogo,
  "Bank 99": IconBank99SmallLogo,
  BTVAAT22: IconBtvSmallLogo,
  BTVAAT22XXX: IconBtvSmallLogo,
  OBKLAT2L: IconOberbankSmallLogo,
  OBKLAT2LXXX: IconOberbankSmallLogo,
  BFKKAT2K: IconBksSmallLogo,
  BFKKAT2KXXX: IconBksSmallLogo,
  GEBAATWW: IconConsorsFinanzSmallLogo,
  GEBAATWWXXX: IconConsorsFinanzSmallLogo,
  HSEEAT2K: IconAddikoSmallLogo,
  HSEEAT2KXXX: IconAddikoSmallLogo,
  HAABAT2K: IconAnadiSmallLogo,
  HAABAT2KXXX: IconAnadiSmallLogo,
  BAWAATWW: IconBawagLogo,
  BAWAATWWXXX: IconBawagLogo,
  EASYATW1: IconEasybankSmallLogo,
  EASYATW1XXX: IconEasybankSmallLogo,
  SPDAAT21: IconSpardaSmallLogo,
  SPDAAT21XXX: IconSpardaSmallLogo,
  EHBBAT2E: IconBankBurgenlandSmallLogo,
  EHBBAT2EXXX: IconBankBurgenlandSmallLogo,
  WISMATWW: IconBankWinterSmallLogo,
  WISMATWWXXX: IconBankWinterSmallLogo,
  BSSWATWW: IconBankhausSchelhammerSmallLogo,
  BSSWATWWXXX: IconBankhausSchelhammerSmallLogo,
  SPAEAT2S: IconBankhausSpanglerSmallLogo,
  SPAEAT2SXXX: IconBankhausSpanglerSmallLogo,
  GIBAATWW: IconErsteSmallLogo,
  GIBAATWWXXX: IconErsteSmallLogo,
  EDBKATWW: IconEdbSmallLogo,
  EDBKATWWXXX: IconEdbSmallLogo,
  BGENATWW: IconGeneraliSmallLogo,
  BGENATWWXXX: IconGeneraliSmallLogo,
  HYPNATWW: IconHypoNoeSmallLogo,
  HYPNATWWXXX: IconHypoNoeSmallLogo,
  HYPTAT22: IconHypoTirolSmallLogo,
  HYPTAT22XXX: IconHypoTirolSmallLogo,
  HYPVAT2B: IconHypoVorarlbergSmallLogo,
  HYPVAT2BXXX: IconHypoVorarlbergSmallLogo,
  DABAIE2D: IconJuniSmallLogo,
  DABAIE2DXXX: IconJuniSmallLogo,
  NTSBDEB1: IconN26SmallLogo,
  NTSBDEB1XXX: IconN26SmallLogo,
  PPLXLUL2: IconPaypalSmallLogo,
  PPLXLUL2XXX: IconPaypalSmallLogo,
  RZBAATWW: IconRbLogo,
  RZBAATWWXXX: IconRbLogo,
  REVOLT21: IconRevolutSmallLogo,
  REVOLT21XXX: IconRevolutSmallLogo,
  SWNQFR21: IconSwanSmallLogo,
  SWNQFR21XXX: IconSwanSmallLogo,
  SCHOATWW: IconSchoellerbankSmallLogo,
  SCHOATWWXXX: IconSchoellerbankSmallLogo,
  BKAUATWW: IconBankAustriaSmallLogo,
  BKAUATWWXXX: IconBankAustriaSmallLogo,
  CAIBATWW: IconBankAustriaUnicreditSmallLogo,
  CAIBATWWXXX: IconBankAustriaUnicreditSmallLogo,
  VRBKAT21: IconVrBankSmallLogo,
  VRBKAT21XXX: IconVrBankSmallLogo,
  VBOEAT2WWNOM: IconVolksbankNoeSmallLogo,
  VBWEAT2W: IconVolksbankOoeSmallLogo,
  VBWEAT2WXXX: IconVolksbankOoeSmallLogo,
  VBOEAT2WWSAL: IconVolksbankSalzburgSmallLogo,
  VBOEATWWGRA: IconVolksbankSteiermarkSmallLogo,
  VBOEATWBINN: IconVolksbankTirolSmallLogo,
  VOVBAT2B: IconVolksbankVorarlbergSmallLogo,
  VOVBAT2BXXX: IconVolksbankVorarlbergSmallLogo,
  VBOEATWW: IconVolksbankWienSmallLogo,
  VBOEATWWKLA: IconVolksbankKaerntenSmallLogo,
  OVLIAT21: IconDolomitenSmallLogo,
  OVLIAT21XXX: IconDolomitenSmallLogo,
  MVOGAT22: IconMarchfelderSmallLogo,
  MVOGAT22XXX: IconMarchfelderSmallLogo,
  BWFBATW1: IconAerzteApothekerbankSmallLogo,
  BWFBATW1XXX: IconAerzteApothekerbankSmallLogo,
  WAMOFRPP: IconWamoSmallLogo,
  WAMOFRPPXXX: IconWamoSmallLogo,
  TRWIBEB1: IconWiseSmallLogo,
  TRWIBEB1XXX: IconWiseSmallLogo,
  // BIC values exactly as paymentProviderEnum spells them
  VBOEATWWNOM: IconVolksbankNoeSmallLogo,
  VBOEATWWOOE: IconVolksbankOoeSmallLogo,
  VBOEATWWSAL: IconVolksbankSalzburgSmallLogo,
  VBOEATWWINN: IconVolksbankTirolSmallLogo,
  VBOEATWWXXX: IconVolksbankWienSmallLogo,
  SPBAATWWXXX: IconBank99SmallLogo,
  TRWIBEBB: IconWiseSmallLogo,
  INGBCZPP: IconIngLogo,
  INGBCZPPXXX: IconIngLogo,
  INGDDEFF: IconIngLogo,
  BBRUBEBBXXX: IconIngLogo,
  INGBNL2AXXX: IconIngLogo,
  INGBROBUXXX: IconIngLogo,
  UNCRSKBX: IconUnicreditLogo,
  BACXHUHBXXX: IconUnicreditLogo,
  UNCRITMMXXX: IconUnicreditLogo,
  BACXROBUXXX: IconUnicreditLogo,
  BACXSI22XXX: IconUnicreditLogo,
  UNCRBGSFXXX: IconUnicreditLogo,
  UBRTHUHBXXX: IconRbLogo,
  RZBHHR2XXXX: IconRbLogo,
  RZBRROBUXXX: IconRbLogo,
  GIBAHUHBXXX: IconErsteSmallLogo,
  ESBCHR22XXX: IconErsteSmallLogo,
  WBKPPLPP: IconErsteSmallLogo,
  FIOZSKBA: IconFioLogo,
  KOMBSKBA: IconKbLogo,
  QNTOFRP1XXX: IconQontoLogo,
  REVONL22XXX: IconRevolutSmallLogo,
  REVOROBBXXX: IconRevolutSmallLogo,
  OBKLCZ2XXXX: IconOberbankSmallLogo,
  HAABSI22XXX: IconAddikoSmallLogo,
  MIDLCZPP: IconHsbcLogo,
  MIDLCZPPXXX: IconHsbcLogo,
  GEBACZPP: IconBnpParibasLogo,
  GEBACZPPXXX: IconBnpParibasLogo,
  PPABPLPK: IconBnpParibasLogo,
  CITIPLPX: IconCitiHandlowyLogo,
  SOLADEST: IconLbbwLogo,
  WELADED1GRL: IconSparkasseLogo,
  BNPAFRPPXXX: IconBnpParibasLogo,
  GEBABEBBXXX: IconBnpParibasLogo,
  ZABAHR2XXXX: IconUnicreditLogo,
  KSPKSI22XXX: IconSparkasseLogo,
} as const;

export interface BankLogoProps extends Omit<
  React.SVGProps<SVGSVGElement>,
  "src" | "alt"
> {
  bank: BankKeys;
}

export const BankLogo = ({ bank, ...props }: BankLogoProps) => {
  //IconBgLogo is used as a fallback for unknown banks
  const Logo = bankLogoMap[bank] ?? IconBcLogo;
  return <Logo {...props} />;
};
